import React from 'react'

import { Button } from 'common/builder/components/chart/FlowChart/components/Button/Button'
import {
  ContainerAppearance,
  ContentContainer,
} from 'common/builder/components/chart/FlowChart/components/ContentContainer/ContentContainer'
import { AttachmentAppearance } from 'common/builder/components/chart/FlowChart/types/AttachmentAppearance'
import { FlowChartButton } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'

import * as styles from './AttachmentButtons.styles'

interface AttachmentButtonsProps {
  buttons: FlowChartButton[]
  attachmentAppearance: AttachmentAppearance
}

export const AttachmentButtons = ({ buttons, attachmentAppearance }: AttachmentButtonsProps) => {
  if (buttons.length === 0) {
    return null
  }

  const appearance =
    attachmentAppearance === AttachmentAppearance.EXTERNAL
      ? ContainerAppearance.EXTERNAL
      : ContainerAppearance.DEFAULT

  return (
    <ContentContainer connectedToPrevious appearance={appearance}>
      {buttons.map((button, index) => (
        <Button
          button={button}
          key={button.id}
          style={index === 0 ? styles.FirstButton : undefined}
        />
      ))}
    </ContentContainer>
  )
}
